/*This will render a wrapper around a children based on a condition */
const ConditionalWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children ?? null;

export default ConditionalWrapper;
